// extracted by mini-css-extract-plugin
export default {"root":"_QeqRuYZ6BLPZCbjq5Id"};